import { type ReactElement } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { ConnectionsTab } from '@/components/connectors/connections-tab';
import { connectionsSearchSchema } from '@/components/connectors/connections-search';
import { ROUTES } from '@/constants/routes';
import { loadNamespaces } from '@/lib/i18n/i18n';

const PICKER_ROUTES = {
  google: '/connect-google-account',
  meta: '/connect-meta-assets',
  ga4: '/connect-ga4-property',
  gtm: '/connect-gtm-container',
} as const;

const isPickerPlatform = (
  platform: string | undefined,
): platform is keyof typeof PICKER_ROUTES =>
  platform !== undefined && Object.hasOwn(PICKER_ROUTES, platform);

export const Route = createFileRoute('/_authenticated/connectors')({
  loader: () => loadNamespaces('settings'),
  validateSearch: connectionsSearchSchema,
  staticData: {
    title: 'route.connectors.title',
  },
  beforeLoad: ({ search }) => {
    if (
      search.status === 'select_account' &&
      search.pending &&
      isPickerPlatform(search.platform)
    ) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: PICKER_ROUTES[search.platform],
        search: { pending: search.pending, from: ROUTES.CONNECTORS },
        replace: true,
      });
    }
  },
  component: ConnectorsPage,
});

function ConnectorsPage(): ReactElement {
  return (
    <main className="mx-auto flex w-full max-w-285 flex-1 flex-col gap-4 px-4 pt-5 pb-12 sm:px-9 sm:pt-7 sm:pb-20">
      <ConnectionsTab />
    </main>
  );
}
